var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconServiceStroller(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55.927,
    height: 59.016,
    viewBox: "0 0 55.927 59.016",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_38754",
    "data-name": "\\uADF8\\uB8F9 38754",
    transform: "translate(-757.709 -1066.301)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_18431",
    "data-name": "\\uC0AC\\uAC01\\uD615 18431",
    d: "M0,0H45.747a0,0,0,0,1,0,0V.051A22.543,22.543,0,0,1,23.2,22.593h-.662A22.543,22.543,0,0,1,0,.051V0A0,0,0,0,1,0,0Z",
    transform: "translate(759.209 1096.239)",
    fill: "none",
    stroke: "#000c7a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_19490",
    "data-name": "\\uD328\\uC2A4 19490",
    d: "M21.362,0h4.466a2.611,2.611,0,0,1,2.611,2.611V28.439H0V19.978C0,11.293,5.359,0,21.362,0Z",
    transform: "translate(759.209 1067.801)",
    fill: "none",
    stroke: "#000c7a",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_19488",
    "data-name": "\\uD328\\uC2A4 19488",
    d: "M819.271,1098.885s-.877-13.181,13.154-13.181",
    transform: "translate(-20.289 -2.645)",
    fill: "none",
    stroke: "#000c7a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_79",
    "data-name": "\\uD0C0\\uC6D0 79",
    cx: 5.967,
    cy: 5.967,
    rx: 5.967,
    ry: 5.967,
    transform: "translate(766.54 1111.883)",
    fill: "#fff",
    stroke: "#f09",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_80",
    "data-name": "\\uD0C0\\uC6D0 80",
    cx: 5.967,
    cy: 5.967,
    rx: 5.967,
    ry: 5.967,
    transform: "translate(788.305 1111.883)",
    fill: "#fff",
    stroke: "#f09",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconServiceStroller);
export default __webpack_public_path__ + "static/media/icon-service-stroller.13a59c59d4abfa455597c98393c8f569.svg";
export { ForwardRef as ReactComponent };